import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import { createSelector } from 'reselect';
import { updateDeviceStates } from '../reducers/device_states';
import { reducers } from '../reducers/index';
const middlewares = [];
if (process.env.NODE_ENV !== 'production') {
    const logger = createLogger({
        predicate: (getState, action) => {
            var _a, _b;
            const log_redux_state_changes = ((_a = localStorage.getItem('log_redux_state_changes')) !== null && _a !== void 0 ? _a : '0') == '1';
            const log_device_state_changes = ((_b = localStorage.getItem('log_device_state_changes')) !== null && _b !== void 0 ? _b : '0') == '1';
            return log_redux_state_changes && (log_device_state_changes || action.type !== updateDeviceStates.type);
        }
    });
    middlewares.push(logger);
}
export const store = configureStore({
    reducer: combineReducers(Object.assign({}, reducers)),
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(...middlewares),
});
export const createAppSelector = createSelector.withTypes();
